// removed by extract-text-webpack-plugin
module.exports = {"linchen-shape":"linchen-shape","flash":"flash"};


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/FrameWork/Shape/index.less
// module id = 681
// module chunks = 438